<template>
    <div class="dhowRight-tabs position-relative">
        <app-loader v-if="pageLoader"/>
        <span class="closePOP" @click.stop="$parent.close()"><feather size="13px" type="x"></feather></span>
        <div class="formRow pt-5 text-center d-flex flex-column justify-content-center h-100">
            <p class="f-16 text-center mb-3" v-if="parseInt(get_user.profile.u2fa_flag) == 1">
                {{$t('disable_two_factor_auth') }} </p>
            <p class="f-16 text-center mb-3" v-else>{{$t('enable_two_factor_authentication') }} </p>
            <div v-if="div_show == ''">
                <div class="twoFA"  v-if="parseInt(get_user.profile.u2fa_flag) == 1">
                    <p class="f-12 opacity-7"> {{$t('2fa_already_enabled') }} </p>
                    <div class="fullWidh w-100 text-center mt-5">
                        <a href="#" class="btn appButton redBG mx-auto justify-content-center uppercase" @click="enable_disable_func('2')">{{$t('disable') }} </a>
                    </div>
                </div>
                <div class="twoFA"  v-else>
                    <p class="f-12 opacity-7">{{$t('please_click_2fa_enable') }} </p>
                    <div class="fullWidh w-100 text-center mt-5">
                        <a href="#" class="btn appButton greenBG mx-auto justify-content-center uppercase" @click="enable_disable_func('1')">{{$t('enable') }}</a>
                    </div>
                </div>
            </div>
            <div class="showAuthentication left-0 w-100" v-if="div_show == '1'">
                <p class="f-12 opacity-7">{{$t('please_click_2fa_enable') }} </p>
                <div class="downloadTwo-fa text-left mt-5 border-bottom">
                    <p class="f-14 mb-2">{{$t('download_authenticator_app') }} </p>
                    <p class="sm">{{$t('download_install_google_authenticator') }} </p>
                </div>
                <div class="downloadTwo-fa py-3 mb-3 d-flex justify-content-between text-left border-bottom">
                    <div class="leftAuth">
                        <p class="f-14 mb-2">{{$t('scan_code') }} </p>
                        <p class="sm">{{$t('open_authentication_app_camera') }}</p>
                    </div>
                    <div class="rigtScan">
                        <img :src="QrCodeImage" alt="Icon" v-if="QrCodeImage"/>
                    </div>
                </div>
                <div class="downloadTwo-fa text-left custmMT">
                    <form class="updateWrap">
                        <div class="form-fields">
                            <p class="m-0 f-14 mb-2">{{$t('login_code') }} </p>
                            <p class="sm">{{$t('enter_6_digit_code') }} </p>
                            <input type="text" placeholder="Enter 6-digit Code" name="otp" v-model="otp" maxlength="6" v-validate="'required|numeric|min:6'"/>
                            <span class="text-danger" v-if="submitted && errors.has('otp')">{{ errors.first('otp') }}</span>
                            <span class="text-danger" v-if="submitted && otpError">{{ otpError }}</span>
                        </div>
                    </form>
                </div>
                <div class="fullWidh w-100 text-center mt-5">
                    <a href="#" class="btn appButton greenBG mx-auto justify-content-center uppercase" @click="verifyQrCode()">{{$t('enable') }} </a>
                </div>
            </div>
            <div class="showAuthentication left-0 w-100" v-if="div_show == '2'">
                <div class="downloadTwo-fa text-center custmMT">
                    <form class="updateWrap">
                        <div class="form-fields">
                            <!-- <p class="m-0 f-14 mb-2">Log in with your Code</p> -->
                            <p class="sm">{{$t('enter_6_digit_code') }} </p>
                            <input type="text" placeholder="Enter 6-digit Code" name="DisableOtp" v-model="DisableOtp" maxlength="6" v-validate="'required|numeric|min:6'"/>
                            <span class="text-danger" v-if="submit && errors.has('DisableOtp')">{{ errors.first('DisableOtp').replace('DisableOtp','Otp') }}</span>
                            <span class="text-danger" v-if="submit && otpError">{{ otpError }}</span>
                        </div>
                    </form>
                </div>
                <div class="fullWidh w-100 text-center mt-5">
                    <a href="#" class="btn appButton redBG mx-auto justify-content-center uppercase" @click="disableQrCode()">{{$t('disable') }} </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { commonAllmixins } from '@/plugins/commonAll'
export default {
    name: 'Two-FA',
    mixins: [commonAllmixins],
    data() {
        return {
            pageLoader : false,
            otpError : '',
            // enable: false,
            QrCodeImage: '',
            secureKey: '',
            submitted: false,
            submit : false,
            div_show : '',
            otp: '',
            DisableOtp: '',
        }
    },
    methods:{
        enable_disable_func(getData){
            this.div_show = getData
        },
        disableQrCode(){
            const _that = this
            _that.submit = true;
            _that.$validator.validate().then(valid => {
                if (valid) {
                    let input_json={
                        'globalParams' :{
                            'code' : _that.DisableOtp.toString()
                        },
                        'localParams' :{ "parameter" : _that }
                    }
                    _that._runDisable2FaQrcode(input_json)
                }
            })
        },
        verifyQrCode(){
            const _that = this
            this.submitted = true;
            this.otpError = '';
            this.$validator.validate().then(valid => {
                if (valid) {
                    let input_json={
                        'globalParams' :{
                            'secureKey' : _that.secureKey,
                            'code' : _that.otp.toString()
                        },
                        'localParams' :{ "parameter" : _that }//, 'call_from' : _that.call_from
                    }
                    _that._runVerify2FaQrcode(input_json)
                }
            })
        },
        generateQrCode(){
            this._runGenerate2FaQrcode({ 'globalParams' : {},'localParams' : { 'parameter' : this } })
        }
    },
    created(){
        if(parseInt(this.get_user.profile.u2fa_flag) == 0){
            this.generateQrCode()
        }
        /*if(this.call_from != '' && this.call_from != null){
            this.enable_disable_func('1')
        }*/
    }
    
}
</script>


// WEBPACK FOOTER //
// src/components/website/user/Two-FA.vue